import React, { useState, useEffect } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import {
	Form,
	Input,
	DatePicker,
	Select,
	Row,
	Col,
	Space,
	message,
	Checkbox,
	Modal,
	InputNumber,
} from "antd";
import {
	InnerForm,
	ProductData,
	PublishSettings,
	Container,
	AntdCheckbox,
	LinkBrand,
	CardContainer,
	Section,
	AntdModal,
	InfoContainer,
} from "./styles";
import { get_market_brands } from "../../../../../../api/endpoints/brands";
import { get_categories } from "../../../../../../api/endpoints/categories";
import { get_active_ingredients } from "../../../../../../api/endpoints/activeIngredients";
import { get_presentations_types } from "../../../../../../api/endpoints/productpresentations";
import {
	openNotificationWithIcon,
	TYPE,
} from "../../../../../../utils/notificationToast";
import { create_combo_product } from "../../../../../../api/endpoints/products";
import moment from "moment";
import DebounceSelect from "../../../../../common/debounce-select/DebounceSelect";
import Main from "../../../../../layout/main/Main";
import ImageGallery from "../../../../../common/image-gallery/ImageGallery";
import { get_tags } from "../../../../../../api/endpoints/tags";
import Typo from "../../../../../layout/theme/typo/Typo";
import SignInTemplate from "../../../../../layout/sign-in-template/SignInTemplate";
import COLORS from "../../../../../layout/theme/colors/Colors";
import UploadFileImage from "../../../../../common/upload-file-with-image/UploadFileImage";
import {
	get_clients_name_list,
	get_client_by_id,
} from "../../../../../../api/endpoints/clients";
import DistributorsFilteredByClient from "../../../../../common/distributor-code-by-client/DistributorsFilteredByClient";
import DebounceBrand from "./components/debounce-select/DebounceSelect";
import CreateBrandModal from "./components/create-brand/CreateBrandModal";
import { CloseCircleOutlined } from "@ant-design/icons";
import ProductCard from "./components/product-card/ProductCard";
import { useAuth } from "../../../../../../contexts/authContext";
import AddProductsComboTable from "../../../../../common/add-products-combo-table/AddProductsComboTable";

const { TextArea } = Input;
const { Option } = Select;
const { RangePicker } = DatePicker;
const GUTTER = 10;

const getBase64 = (img, callback) => {
	const reader = new FileReader();
	reader.addEventListener("load", () => callback(reader.result));
	reader.readAsDataURL(img);
};

const states = [
	{
		id: "PAUSED",
		name: "Pausado",
	},
	{
		id: "PUBLISHED",
		name: "Publicado",
	},
];

export default function CreateMarketComboProduct() {
	const [form] = Form.useForm();
	const navigate = useNavigate();
	const { user } = useAuth();
	const [searchParams] = useSearchParams();
	const uri = searchParams.get("uri");

	const [submitting, setSubmitting] = useState(false);
	const [brands, setBrands] = useState([]);
	const [presentationTypes, setPresentationTypes] = useState([]);
	const [imageUrl, setImageUrl] = useState();
	const [distributors, setDistributors] = useState(null);
	const [categories, setCategories] = useState(null);
	const [activeIngredients, setActiveIngredients] = useState(null);
	const [relatedProducts, setRelatedProducts] = useState(null);
	const [photoGallery, setPhotoGallery] = useState([]);
	const [tags, setTags] = useState(null);
	const [show, setShow] = useState(null);
	const [publish, setPublish] = useState(null);
	const [defaultTag, setDefaultTag] = useState(null);
	const [clients, setClients] = useState(null);
	const [selectedClient, setSelectedClient] = useState(null);
	const [offerPriceByDiscount, setOfferPriceByDiscount] = useState(null);
	const [productPrice, setProductPrice] = useState(0);
	const [unitName, setUnitName] = useState(null);
	const [clientSelected, setClientSelected] = useState(null);
	const [commisionInput, setCommisionInput] = useState(null);
	const [productDiscount, setProductDiscount] = useState(0);
	const [showTriggerQtyDiscount, setShowTriggerQtyDiscount] = useState(false);
	const [aICheckbox, setAICheckbox] = useState(false);
	const [eanCode, setEanCode] = useState("");
	const [brandsForDebounce, setBrandsForDebounce] = useState(false);
	const [open, setOpen] = useState(false);
	const [showFirstDiscount, setShowFirstDiscount] = useState(false);
	const [showProductsModal, setShowProductsModal] = useState(false);
	const [productsForCombo, setProductsForCombo] = useState([]);

	const disabledDate = (current) => {
		return current && current < moment().add(-1, "days").endOf(-1, "day");
	};

	const handlePublish = (e) => {
		setPublish(e);
	};

	useEffect(() => {
		const fetch_brands = async () => {
			const data = await get_market_brands();
			setBrands(data.filter((b) => b.clientId === selectedClient) || []);
		};

		selectedClient && fetch_brands();
	}, [selectedClient]);

	useEffect(() => {
		const fetch_contract = async () => {
			const data = await get_client_by_id(selectedClient);
			setClientSelected(data.client);
			setCommisionInput(data.client.contract?.salesCommision);
		};

		selectedClient && fetch_contract();
	}, [selectedClient]);

	const fetch_presentation_types = async () => {
		const data = await get_presentations_types();
		setPresentationTypes(data || []);
	};

	useEffect(() => {
		window.scrollTo(0, 0);
		fetch_presentation_types();
	}, []);

	useEffect(() => {
		const fetch_tags = async (term) => {
			const res = await get_tags(term);
			setTags(res || []);
		};
		fetch_tags();
	}, []);

	useEffect(() => {
		const fetch_market_products_total = async () => {
			const res = await get_clients_name_list();
			setClients(
				res
					?.filter((c) => c.isApproved)
					?.map((r) => ({
						value: r.id,
						label: r.name,
					}))
			);
		};

		fetch_market_products_total();
	}, []);

	const fetch_categories = async (term) => {
		const res = await get_categories(term);

		return res.map((r) => ({
			label: r.name,
			value: r.id,
		}));
	};

	const fetch_active_ingredients = async (term) => {
		const res = await get_active_ingredients(term);

		return res.map((r) => ({
			label: r.name,
			value: r.id,
		}));
	};

	const fetch_brands_for_debounce = async (term) => {
		const res = await get_market_brands(term);

		return res
			.filter((b) => b.clientId === selectedClient)
			.map((r) => ({
				label: r.name,
				value: r.id,
			}));
	};

	const newBrand = () => {
		setOpen(true);
	};

	const onFinish = async (values) => {
		try {
			if (eanCode === "" || eanCode.length !== 13) {
				openNotificationWithIcon(
					TYPE.ERROR,
					"El código Ean13 no puede ser vacío o debe tener 13 caracteres"
				);
				setSubmitting(false);
				return;
			}
			if (
				brandsForDebounce.value === null ||
				brandsForDebounce.value === undefined
			) {
				openNotificationWithIcon(TYPE.ERROR, "La marca es obligatoria");
				setSubmitting(false);
				return;
			}

			const _aux = distributors.filter(
				(i) => i.code === "" || i.code === "si" || i.code === null
			);

			if (distributors.length - _aux.length === 0) {
				setSubmitting(false);
				openNotificationWithIcon(
					TYPE.ERROR,
					"Para avanzar debe colocar al menos un código de Drogueria"
				);
				return;
			}

			const _auxComboProducts = productsForCombo?.map((p) => ({
				productId: p.id,
				productDiscount: parseFloat(p.discount).toFixed(2),
				productQuantity: p.quantity,
			}));

			const _auxComboPrice = productsForCombo?.reduce(
				(acc, item) => acc + item.price * item.quantity,
				0
			);
			const _auxComboOfferPrice = productsForCombo?.reduce(
				(acc, item) =>
					acc +
					(item.price * item.quantity -
						item.clientGeneralDiscount * ((item.price * item.quantity) / 100) -
						(parseFloat(item.discount) / 100) *
							(item.price * item.quantity -
								item.clientGeneralDiscount *
									((item.price * item.quantity) / 100))),
				0
			);

			setSubmitting(true);

			const postData = {
				activeIngredients: aICheckbox
					? ["839218AB-7A6E-432B-AF8C-D41BBBE000D7"]
					: activeIngredients?.map((i) => i.value),
				brandId: brandsForDebounce.value,
				categories: categories?.map((i) => i.value),
				ean13: eanCode,
				shortDescription: values.shortDesc,
				longDescription: values.longDesc,
				publishFrom: moment(values.publishFrom).format("YYYY-MM-DD"),
				publishTo: moment(values.publishFrom)
					.add(3000, "y")
					.format("YYYY-MM-DD"),
				price: _auxComboPrice,
				offerPrice: _auxComboOfferPrice,
				discount: 0,
				presentationId: values.presentationType,
				presentationQty: values.presentationQty,
				state: values.state,
				title: values.title,
				distributors: distributors.map((d) => ({
					id: d.id,
					code: d.code,
				})),
				relatedProductsOf: relatedProducts?.map((i) => i.value),
				tag: defaultTag,
				clientId: values.clientId,
				saleCommision: commisionInput,
				minQuantity: 1,
				maxQuantity: 999,
				triggerQty: 0,
				triggerDiscount: 0,
				isComboProduct: true,
				comboProducts: _auxComboProducts,
				notes: values.notes,
			};

			const formData = new FormData();
			formData.append(
				"file",
				values.file?.fileList?.slice(-1)[0]?.originFileObj
			);
			photoGallery.forEach((f) => {
				formData.append("files", f.originFileObj);
			});

			formData.append("data", JSON.stringify(postData));

			const res = await create_combo_product(formData);
			navigate(`/admin/marketProductsIndex?uri=${uri}`);

			openNotificationWithIcon(
				TYPE.SUCCESS,
				"Combo creado con exito",
				"El combo se creo con exito"
			);
		} catch (error) {
			console.log(error);
			openNotificationWithIcon(
				TYPE.ERROR,
				"Error al crear el combo",
				"Un error ocurrio al intentar crear el combo, contacte con soporte a soporte@checkpos.com."
			);
		} finally {
			setSubmitting(false);
		}
	};

	const handleImageChange = (info) => {
		try {
			const isJpgOrPng =
				info.file.type === "image/jpeg" || info.file.type === "image/png";

			if (!isJpgOrPng) {
				message.error("You can only upload JPG/PNG file!");
			}

			const isLt2M = info.file.size / 1024 / 1024 < 2;

			if (!isLt2M) {
				message.error("Image must smaller than 2MB!");
			}

			if (!isJpgOrPng || !isLt2M) return;

			getBase64(
				info.fileList[info.fileList.length - 1].originFileObj,
				(url) => {
					setImageUrl(url);
				}
			);
		} catch (error) {
			console.log(error);
		}
	};

	const handlePhotoGalleryChange = (values) => {
		setPhotoGallery(values);
	};

	const handleClientSelect = (value, object) => {
		setSelectedClient(object.value);
	};

	const handlePresentationChange = (value) => {
		setUnitName(presentationTypes.filter((p) => p.id === value)[0]?.unit?.name);
	};

	const handleEanCodeInput = (e) => {
		setEanCode(e.target.value);
	};

	const handleBack = () => {
		Modal.confirm({
			title: "¿Seguro que quiere volver sin guardar?",
			icon: <CloseCircleOutlined style={{ color: "red" }} />,
			content:
				"Si regresa sin guardar se perderán los datos que hayan sido cargados",
			okText: "Sí",
			okType: "danger",
			cancelText: "No",
			onOk: () => {
				navigate("/admin/marketProductsIndex?uri=" + uri);
			},
		});
	};

	const handleModalOk = () => {
		setShowProductsModal(false);
	};

	const handleModalCancel = () => {
		setShowProductsModal(false);
	};

	return (
		<Main>
			<Main.Header>
				<Main.Breadcrumb>
					<Main.BreadcrumbItem>
						{uri ? (
							<Link to={"/" + uri}>Configuración General</Link>
						) : (
							<Link to="/">Home</Link>
						)}
					</Main.BreadcrumbItem>
					<Main.BreadcrumbSeparator />
					<Main.BreadcrumbItem>
						<Link to={"/admin/marketProductsIndex?uri=" + uri}>
							{uri ? "Productos y ofertas" : "Productos y Precios"}
						</Link>
					</Main.BreadcrumbItem>
					<Main.BreadcrumbSeparator />
					<Main.ActiveBreadcrumbItem>Crear Combo</Main.ActiveBreadcrumbItem>
				</Main.Breadcrumb>
			</Main.Header>

			<Main.Body>
				<Form
					form={form}
					name="create-marketProduct"
					onFinish={onFinish}
					autoComplete="off"
					requiredMark={false}
					layout="vertical"
				>
					<InnerForm>
						<ProductData>
							<CardContainer>
								<Row gutter={GUTTER}>
									<Col span={24}>
										<Form.Item
											label={
												<label
													style={{ color: COLORS.Primary, fontWeight: "600" }}
												>
													Laboratorio
												</label>
											}
											name="clientId"
											rules={[
												{
													required: true,
													message: "Este campo es obligatorio",
												},
											]}
										>
											<Select
												showSearch
												placeholder="Elegi un cliente"
												optionFilterProp="children"
												onChange={handleClientSelect}
												value={
													selectedClient !== "null" ? selectedClient : "..."
												}
												filterOption={(input, option) =>
													(option?.label ?? "")
														.toLowerCase()
														.includes(input.toLowerCase())
												}
												options={clients}
											/>
										</Form.Item>
									</Col>
								</Row>
								<Row gutter={GUTTER}>
									<Col span={24}>
										<Form.Item
											label={
												<label
													style={{ color: COLORS.Primary, fontWeight: "600" }}
												>
													Nombre
												</label>
											}
											name="title"
											rules={[
												{
													required: true,
													message: "Este campo es obligatorio",
												},
												{
													pattern: new RegExp(
														/^(?![-.\(\)\s]*$)[-.\(\)a-zA-ZÀ-ÿ0-9\s]*$/
													),
													message:
														"No se aceptan caracteres especiales. Solo letras y numeros",
												},
											]}
										>
											<Input placeholder="Nombre" />
										</Form.Item>
									</Col>
								</Row>
								<Row gutter={GUTTER}>
									<Col span={8}>
										<Form.Item
											label={
												<label
													style={{ color: COLORS.Primary, fontWeight: "600" }}
												>
													Contenido del Envase
												</label>
											}
											name="presentationType"
											rules={[
												{
													required: true,
													message: "Este campo es obligatorio",
												},
											]}
										>
											<Select
												allowClear={true}
												placeholder="Contenido del Envase"
												onChange={handlePresentationChange}
											>
												{presentationTypes.map((item) => (
													<Option key={item.id} value={item.id}>
														{item.name}
													</Option>
												))}
											</Select>
										</Form.Item>
									</Col>
									<Col md={6} xl={6} style={{ display: "flex" }}>
										<Form.Item
											label={
												<label
													style={{
														color: COLORS.Primary,
														fontWeight: "600",
														whiteSpace: "nowrap",
													}}
												>
													Cantidad de presentación
												</label>
											}
											name="presentationQty"
											rules={[
												{
													required: true,
													message: "Este campo es obligatorio",
												},
												{
													pattern: new RegExp(/^(?!\s*$)[0-9\s]*$/),
													message: "Solo numeros positivos",
												},
											]}
										>
											<Input
												type="number"
												placeholder="Cantidad"
												style={{ width: 100, marginRight: 10 }}
												min={1}
											/>
										</Form.Item>
									</Col>
									<Col md={6} xl={6}>
										<Form.Item
											label={
												<label
													style={{ color: COLORS.Primary, fontWeight: "600" }}
												>
													Código EAN
												</label>
											}
											name="ean13"
											rules={[
												{
													required: true,
													message: "Este campo es obligatorio",
												},
												{
													len: 13,
													message: "El ean debe de ser de 13 digitos",
												},
												{
													pattern: new RegExp(/^(?!\s*$)[a-zA-ZÀ-ÿ0-9\s]*$/),
													message:
														"No se aceptan caracteres especiales. Solo letras y numeros",
												},
											]}
										>
											<Input
												value={eanCode}
												defaultValue={eanCode}
												onChange={handleEanCodeInput}
												placeholder="Código EAN"
											/>
										</Form.Item>
									</Col>
								</Row>
							</CardContainer>
							<CardContainer>
								<Row>
									<Col span={24}>
										<Form.Item
											label={
												<label
													style={{ color: COLORS.Primary, fontWeight: "600" }}
												>
													Descripción Corta
												</label>
											}
											name="shortDesc"
											rules={[
												{
													required: true,
													message: "Este campo es obligatorio",
												},
											]}
										>
											<Input placeholder="Descripción Corta" />
										</Form.Item>
									</Col>
								</Row>

								<Row>
									<Col span={24}>
										<Form.Item
											label={
												<label
													style={{ color: COLORS.Primary, fontWeight: "600" }}
												>
													Descripción Larga
												</label>
											}
											name="longDesc"
											rules={[
												{
													required: true,
													message: "Este campo es obligatorio",
												},
											]}
										>
											<TextArea rows={3} placeholder="Descripción Larga" />
										</Form.Item>
									</Col>
								</Row>

								<Row>
									<Col md={12} xl={12}>
										<Form.Item
											label={
												<label
													style={{ color: COLORS.Primary, fontWeight: "600" }}
												>
													Información de descuento
												</label>
											}
											name="notes"
											rules={[]}
										>
											<Input
												placeholder="descuento"
												prefix={
													<div
														style={{
															width: "100%",
															paddingRight: 10,
														}}
													>
														<Typo
															type="mediumGrey"
															level={6}
															texto="inputLabel"
														>
															Hasta
														</Typo>
													</div>
												}
												suffix={
													<div style={{ width: "100%" }}>
														<Typo
															type="mediumGrey"
															level={6}
															texto="inputLabel"
														>
															% off
														</Typo>
													</div>
												}
												style={{ width: "150px" }}
											/>
										</Form.Item>
									</Col>
								</Row>

								<Row gutter={GUTTER}>
									<Col md={4} xl={4}>
										<Form.Item
											name="file"
											label={
												<label
													style={{ color: COLORS.Primary, fontWeight: "600" }}
												>
													Imagen principal
												</label>
											}
											rules={[
												{
													required: true,
													message: "Este campo es obligatorio",
												},
											]}
										>
											<UploadFileImage
												onChange={handleImageChange}
												urlImage={imageUrl}
												imageHeight="100%"
												imageWidth="100%"
											/>
										</Form.Item>
									</Col>
									<Col md={14} xl={14}>
										<Form.Item
											label={
												<label
													style={{
														color: COLORS.Primary,
														fontWeight: "600",
													}}
												>
													Galeria
												</label>
											}
										>
											<ImageGallery
												data={photoGallery}
												onChange={handlePhotoGalleryChange}
											/>
										</Form.Item>
									</Col>
								</Row>
							</CardContainer>
							<CardContainer>
								{selectedClient && (
									<>
										<SignInTemplate.AntdButton
											type="Primary"
											color="white"
											bg="Primary"
											onClick={() => setShowProductsModal(true)}
											loading={submitting}
											style={{ width: "200px" }}
										>
											Asignar productos
										</SignInTemplate.AntdButton>
										<Section>
											{productsForCombo?.map((p, idx) => (
												<ProductCard key={idx} product={p} />
											))}
										</Section>
									</>
								)}
							</CardContainer>
							<AntdModal
								visible={showProductsModal}
								onOk={handleModalOk}
								onCancel={handleModalCancel}
								width={1200}
								centered={true}
								footer={null}
								destroyOnClose={true}
							>
								<InfoContainer>
									<AddProductsComboTable
										templateProducts={productsForCombo}
										setTemplateProducts={setProductsForCombo}
										userId={user.uid}
										laboratoryId={selectedClient}
										isMultiLab={false}
									/>
								</InfoContainer>
							</AntdModal>
							<CardContainer>
								{selectedClient && (
									<Row gutter={GUTTER}>
										<Col span={18}>
											<Form.Item
												label={
													<label
														style={{ color: COLORS.Primary, fontWeight: "600" }}
													>
														Droguerías
													</label>
												}
											>
												<DistributorsFilteredByClient
													initialValues={distributors}
													onChange={setDistributors}
													ean13={eanCode}
													clientId={selectedClient}
												/>
											</Form.Item>
										</Col>
									</Row>
								)}
							</CardContainer>
						</ProductData>

						<PublishSettings>
							<Container>
								<Space
									direction="vertical"
									size="middle"
									style={{ display: "flex" }}
								>
									<Typo level={5} type="primary">
										Publicación
									</Typo>
									<Form.Item
										label={
											<label
												style={{ color: COLORS.Primary, fontWeight: "600" }}
											>
												Publicar desde
											</label>
										}
										name="publishFrom"
									>
										<DatePicker
											style={{
												width: "100%",
											}}
											onChange={handlePublish}
											disabledDate={disabledDate}
										/>
									</Form.Item>

									<Form.Item
										label={
											<label
												style={{ color: COLORS.Primary, fontWeight: "600" }}
											>
												Estado del producto
											</label>
										}
										name="state"
										rules={[
											{
												required: true,
												message: "Este campo es obligatorio",
											},
										]}
									>
										<Select allowClear={true} placeholder="Estado del producto">
											{states.map((item) => (
												<Option key={item.id} value={item.id}>
													{item.name}
												</Option>
											))}
										</Select>
									</Form.Item>
									<Row gutter={GUTTER}>
										<Col span={24}>
											<Form.Item
												label={
													<label
														style={{
															color: COLORS.Primary,
															fontWeight: "600",
														}}
													>
														Marca
													</label>
												}
												name="brand"
											>
												<DebounceBrand
													fetchCallback={fetch_brands_for_debounce}
													placeholder="Buscar marca"
													onValuesChange={setBrandsForDebounce}
													initialValues={brandsForDebounce}
												/>
												<LinkBrand onClick={() => newBrand()} type="muted">
													{" "}
													Crear Marca
												</LinkBrand>
												<Modal
													title="Crear Marca"
													visible={open}
													footer={null}
													onCancel={() => setOpen(false)}
												>
													<CreateBrandModal
														state={setOpen}
														clientId={selectedClient}
													/>
												</Modal>
											</Form.Item>
										</Col>
									</Row>
									<Row gutter={GUTTER}>
										<Col span={24}>
											<Form.Item
												label={
													<label
														style={{
															color: COLORS.Primary,
															fontWeight: "600",
														}}
													>
														Categorías
													</label>
												}
												rules={[
													{
														required: true,
														message: "Este campo es obligatorio",
													},
												]}
											>
												<DebounceSelect
													fetchCallback={fetch_categories}
													placeholder="Buscar categorias"
													onValuesChange={setCategories}
													initialValues={categories}
												/>
											</Form.Item>
										</Col>
									</Row>
									<Row gutter={GUTTER}>
										<Col span={24}>
											<Form.Item
												label={
													<label
														style={{
															color: COLORS.Primary,
															fontWeight: "600",
														}}
													>
														Principios Activos
													</label>
												}
												rules={[
													{
														required: true,
														message: "Este campo es obligatorio",
													},
												]}
											>
												<DebounceSelect
													fetchCallback={fetch_active_ingredients}
													placeholder="Buscar principios activos"
													onValuesChange={setActiveIngredients}
													initialValues={activeIngredients}
													disabled={aICheckbox}
												/>
											</Form.Item>
										</Col>
									</Row>
									<Row gutter={GUTTER}>
										<Col span={24}>
											<Form.Item
												label={
													<label
														style={{
															color: COLORS.Primary,
															fontWeight: "600",
														}}
													>
														Tipo de Producto
													</label>
												}
												rules={[
													{
														required: true,
														message: "Este campo es obligatorio",
													},
												]}
												name="tagsTipo"
											>
												<Select
													allowClear={true}
													placeholder="Tipo de Producto"
													onChange={(e) => setDefaultTag(e)}
												>
													{tags?.map((item) => (
														<Option key={item.id} value={item.id}>
															{item.name}
														</Option>
													))}
												</Select>
											</Form.Item>
										</Col>
									</Row>

									<Form.Item>
										<SignInTemplate.AntdButton
											type="Primary"
											color="white"
											bg="Primary"
											htmlType="submit"
											loading={submitting}
											block
										>
											Publicar
										</SignInTemplate.AntdButton>
									</Form.Item>
									<SignInTemplate.AntdButton
										type="Primary"
										onClick={handleBack}
										loading={submitting}
										block
									>
										<Typo type="danger" level={6}>
											Volver sin guardar
										</Typo>
									</SignInTemplate.AntdButton>
								</Space>
							</Container>
						</PublishSettings>
					</InnerForm>
				</Form>
			</Main.Body>
		</Main>
	);
}
